

import {createContext, useContext, useEffect, useState} from "react";
import AuthService from "../services/AuthService";
import {clearTokens, decodeToken, setTokens} from "../utils/tokenManager";

import {ROUTES} from "../constants/routes";
import {User} from "../types/api/authorization/user.types";

type AuthContextType = {
    user: User | null;
    loading: boolean;
    login: (login: string, password: string) => Promise<boolean>;
    logout: () => Promise<void>;
    refreshToken: () => Promise<boolean>;
};

const defaultContext: AuthContextType = {
    user: null,
    loading: true,
    login: async () => false,
    logout: async () => {},
    refreshToken: async () => false,
};

const AuthContext = createContext(defaultContext);

export const AuthProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);

    const [user, setUser] = useState<User>({
        accessToken: null,
        id: null,
        login: null,
        rights: [],
        positions: [],
        exp: null
    });

    const buildUser = (data) => {
        if (!data) return {
            accessToken: null,
            id: null,
            login: null,
            rights: [],
            positions: [],
            exp: null
        };

        const { accessToken, decode } = data;
        return {
            accessToken,
            login: decode.login,
            id: decode.id,
            rights: Array.isArray(decode.rights) ? decode.rights : [decode.rights],
            positions: Array.isArray(decode.positions) ? decode.positions : [decode.positions],
            exp: decode.exp,
        };
    };

    useEffect(() => {
        const init = () => {
            console.log("AuthProvider useEffect INIT");
            const data = AuthService.initContext();
            setUser(buildUser(data));
            setLoading(false);
        };
        init();
    }, []);

    const login = async (login, password) => {
        console.log("Test")
        const res = await AuthService.login(login, password);

        const accessToken  = res.data.accessToken;
        if (accessToken){
            setTokens(accessToken);
            const decode = decodeToken(accessToken);
            if (decode)
                setUser(buildUser({accessToken, decode}));
            else
                console.log(res.data);
        }

        return !!res;
    };

    const logout = async () => {
        console.log("test")
        await AuthService.logout();
        setUser(null);
        clearTokens();
        window.location.href = ROUTES.LOGIN.path;
    };

    const refreshToken = async () => {
        const res = await AuthService.refreshToken();

        const { accessToken } = res.data.accessToken;
        setTokens(accessToken);

        const decode = decodeToken(accessToken);

        if (decode)
            setUser(buildUser({accessToken, decode}));
        else
            console.log(res.data);

        return !!res.data;
    };

    return (
        <AuthContext.Provider value={{
            user,
            loading,
            login,
            logout,
            refreshToken
        }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}